export default __webpack_public_path__ + "static/media/lionel_messi.8c6b6d44.png";